import type { Device, Sensor } from '../../types/device'
import { OverviewPanel } from './OverviewPanel'
import { SwitchDetails } from './SwitchDetails'
import { MeteredDetails } from './MeteredDetails'
import { SensorDetails } from './SensorDetails'

interface Props {
  selection: { kind: 'device'; device: Device } | { kind: 'sensor'; sensor: Sensor } | null
  devices: Device[]
  sensors: Sensor[]
  siteName: string
  isAdmin: boolean
  showClose: boolean
  asSheet: boolean
  onClose: () => void
  onBack: (() => void) | null
  onSelect: (id: string) => void
  onToggle: (id: string) => void
  onOpenSchedule: (device: Device) => void
}

function isMetered(d: Device): boolean {
  return d.kind === 'meter-1ph' || d.kind === 'meter-3ph'
}

export function DetailsPanel(props: Props) {
  const { selection, devices, sensors, siteName, isAdmin, showClose, asSheet, onClose, onBack, onSelect, onToggle, onOpenSchedule } = props

  if (!selection) {
    return (
      <OverviewPanel
        devices={devices}
        sensors={sensors}
        siteName={siteName}
        showClose={showClose}
        asSheet={asSheet}
        onClose={onClose}
        onSelect={onSelect}
      />
    )
  }

  if (selection.kind === 'sensor') {
    return (
      <SensorDetails
        sensor={selection.sensor}
        showClose={showClose}
        asSheet={asSheet}
        onClose={onClose}
        onBack={onBack}
      />
    )
  }

  const device = selection.device
  if (isMetered(device)) {
    return (
      <MeteredDetails
        device={device}
        showClose={showClose}
        asSheet={asSheet}
        onClose={onClose}
        onBack={onBack}
      />
    )
  }

  return (
    <SwitchDetails
      device={device}
      isAdmin={isAdmin}
      showClose={showClose}
      asSheet={asSheet}
      onClose={onClose}
      onBack={onBack}
      onToggle={onToggle}
      onOpenSchedule={onOpenSchedule}
    />
  )
}
